import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TopNav from "./components/TopNavBar";
import SideNav from "./components/SideNavBar";
import Login from "./components/Login"; // Import Login component
import PrivateRoute from "./components/PrivateRoute";
import NewsEventSpeech from "./components/pages/NewsEventSpeech";
import EventList from "./components/pages/Events";
import NewsList from "./components/pages/News";
import SpeechList from "./components/pages/Speech";
import HeroFirstSection from "./components/section/HeroFirstSection";
import AllNewsEventsData from "./components/pages/AllNewsEvents"; // Import PrivateRoute component

const App = () => {
  return (
      <Router>
        <div className="bg-gray-100 dark:bg-gray-900 min-h-screen">
          <TopNav />
          <div className="flex">
            <SideNav />
            <div className="flex-1 p-8">
              <Routes>
                {/* Route for login */}
                <Route path="/login" element={<Login />} />

                {/* Protected Routes */}
                <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <h2 className="text-3xl text-black dark:text-white">Dashboard</h2>
                      </PrivateRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                      <PrivateRoute>
                        <h2 className="text-3xl text-black dark:text-white">Users</h2>
                      </PrivateRoute>
                    }
                />

                  <Route
                      path="/news-event-speech"
                      element={
                          <PrivateRoute>
                              <NewsEventSpeech />
                          </PrivateRoute>
                      }
                  />

                  <Route
                      path="/event"
                      element={
                          <PrivateRoute>
                              <EventList />
                          </PrivateRoute>
                      }
                  />
                  <Route
                      path="/news"
                      element={
                          <PrivateRoute>
                              <NewsList />
                          </PrivateRoute>
                      }
                  />
                  <Route
                      path="/all-news-event-speech"
                      element={
                          <PrivateRoute>
                              <AllNewsEventsData />
                          </PrivateRoute>
                      }
                  />

                  <Route
                      path="/speech"
                      element={
                          <PrivateRoute>
                              <SpeechList />
                          </PrivateRoute>
                      }
                  />

                <Route
                    path="/first_section"
                    element={
                      <PrivateRoute>
                        <HeroFirstSection />
                      </PrivateRoute>
                    }
                />
                <Route
                    path="/settings"
                    element={
                      <PrivateRoute>
                        <h2 className="text-3xl text-black dark:text-white">Settings</h2>
                      </PrivateRoute>
                    }
                />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
  );
};

export default App;
